import {
  createActivityForMaterialItem,
  getUnitLessonIdParts,
} from './gDriveUtils'
import { IUnitLessonParams, ParsedGoogleDocType } from './types'
import { createNodeList } from '../nodeCreationHelpers'

export function parseLessonAssessments(params: IUnitLessonParams) {
  const assessments = getLessonAssessments(params)
  if (!assessments.length) return []

  const childNodes = assessments.map((item) => {
    return createActivityForMaterialItem(item)
  })

  return [createNodeList({ title: 'Assessments' }, childNodes)]
}

function getLessonAssessments(params: IUnitLessonParams) {
  const { unitCode, lessonCode } = getUnitLessonIdParts(params)
  const assessmentKey = unitCode + lessonCode + 'SA'
  return Object.entries(params.gDrive).reduce<ParsedGoogleDocType[]>(
    (acc, [key, content]) => {
      if (!key.includes(assessmentKey)) return acc
      return [...acc, content]
    },
    [],
  )
}
